module.exports = __webpack_public_path__ + "static/web-scraping-automation-8fc472adac0ccccd3d2cd33871b318f2.png";